export class SpinnerService {
  constructor() {
    this.spinnerCache = new Set();
  }

  _register(spinner) {
    this.spinnerCache.add(spinner);
  }

  _unregister(spinnerToRemove) {
    this.spinnerCache.forEach(spinner => {
      if (spinner === spinnerToRemove) {
        this.spinnerCache.delete(spinner);
      }
    });
  }

  _unregisterGroup(spinnerGroup) {
    this.spinnerCache.forEach(spinner => {
      if (spinner.props.group === spinnerGroup) {
        this.spinnerCache.delete(spinner);
      }
    });
  }

  _unregisterAll() {
    this.spinnerCache.clear();
  }

  show(spinnerName) {
    this.spinnerCache.forEach(spinner => {
      if (spinner.props.name === spinnerName) {
        spinner.onChangeDisplay(true);
      }
    });
  }

  hide(spinnerName) {
    this.spinnerCache.forEach(spinner => {
      if (spinner.props.name === spinnerName) {
        spinner.onChangeDisplay(false);
      }
    });
  }

  showGroup(spinnerGroup) {
    this.spinnerCache.forEach(spinner => {
      if (spinner.props.group === spinnerGroup) {
        spinner.onChangeDisplay(true);
      }
    });
  }

  hideGroup(spinnerGroup) {
    this.spinnerCache.forEach(spinner => {
      if (spinner.props.group === spinnerGroup) {
        spinner.onChangeDisplay(false);
      }
    });
  }

  showAll() {
    this.spinnerCache.forEach(spinner => spinner.onChangeDisplay(true));
  }

  hideAll() {
    this.spinnerCache.forEach(spinner => spinner.onChangeDisplay(false));
  }

  isShowing(spinnerName) {
    let showing;
    this.spinnerCache.forEach(spinner => {
      if (spinner.props.name === spinnerName) {
        showing = spinner.state.show;
      }
    });
    return showing;
  }
}

const spinnerService = new SpinnerService();
export { spinnerService };
